import { createAction } from 'redux-act'
import { push } from 'react-router-redux'

export const request = createAction('localeData/request')
export const receive = createAction('localeData/receive')

export const fetch = (locale) => (dispatch) => {
  if (!locale) {
    return Promise.reject()
  }

  const currentLocale = window.location.pathname.substr(1, 2)
  const pathname = window.location.pathname
    .replace(`/${currentLocale}/`, `/${locale}/`)

  dispatch(request({ locale }))
  dispatch(push(`${pathname}${window.location.search}${window.location.hash}`))

  return window.fetch(`/locale-data/${locale}.json`)
    .then(response => response.json())
    .then(messages => {
      dispatch(receive({ locale, messages }))
    })
    .catch((error) => {
      if (error instanceof SyntaxError) {
        alert(`Invalid ${locale.toUpperCase()} locale data!`) // eslint-disable-line no-alert
      }
      return Promise.reject(error)
    })
}
